import React from 'react';

const OverviewCard = ({ template, onRefresh, onDelete, loading, saving }) => {
  if (!template) {
    return null;
  }

  const isSystem = template.category === 'system';

  return (
    <section className="prompt-template-detail__card">
      <header className="prompt-template-detail__card-header">
        <div>
          <h2 className="prompt-template-detail__card-title">Overview</h2>
          <p className="prompt-template-detail__card-subtitle">
            Key metadata about the template.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {isSystem && (
            <span className="prompt-template-detail__status-badge prompt-template-detail__status-badge--system">
              System
            </span>
          )}
          <span
            className={`prompt-template-detail__status-badge ${
              template.isActive
                ? 'prompt-template-detail__status-badge--active'
                : 'prompt-template-detail__status-badge--inactive'
            }`}
          >
            {template.isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
      </header>

      <dl className="prompt-template-detail__meta">
        <div className="prompt-template-detail__meta-item">
          <dt>Template ID</dt>
          <dd>{template.id}</dd>
        </div>
        {template.promptKey && (
          <div className="prompt-template-detail__meta-item">
            <dt>Prompt Key</dt>
            <dd>
              <code style={{
                padding: '2px 6px',
                borderRadius: '4px',
                backgroundColor: 'rgba(139, 92, 246, 0.08)',
                color: '#7c3aed',
                fontSize: '12px',
                fontFamily: "'Courier New', monospace",
              }}>
                {template.promptKey}
              </code>
            </dd>
          </div>
        )}
        <div className="prompt-template-detail__meta-item">
          <dt>Version</dt>
          <dd>v{template.version}</dd>
        </div>
        <div className="prompt-template-detail__meta-item">
          <dt>Created</dt>
          <dd>{template.formattedCreatedAt}</dd>
        </div>
        <div className="prompt-template-detail__meta-item">
          <dt>Last Updated</dt>
          <dd>{template.formattedUpdatedAt}</dd>
        </div>
      </dl>

      <div className="prompt-template-detail__card-footer">
        <button
          type="button"
          className="prompt-template-detail__link-button"
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh Details
        </button>
        {!isSystem && (
          <button
            type="button"
            className="prompt-template-detail__link-button prompt-template-detail__link-button--danger"
            onClick={onDelete}
            disabled={saving}
          >
            Delete Template
          </button>
        )}
      </div>
    </section>
  );
};

export default OverviewCard;
